import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { FieldsetBox, LegendStyled } from '../styling/StyledComponents';

const hourChoices = Array.from({length: 24}, (v, k) => k+1)

export default function HourFilter(props) {
  const { userParams, selectOptions, handleChange } = props;

  return (
    <FieldsetBox component="fieldset" sx={{ mt:1 }}>
        <LegendStyled>Hour range (LST)</LegendStyled>
        <Typography variant="body2" sx={{ mb: 1, fontStyle: 'italic' }}>
        For each day, use hours:
        </Typography>
        <Stack direction="row" spacing={0}>
            <TextField sx={{ m:0 }}
              select
              name="fromFilterHour"
              value={userParams.fromFilterHour}
              onChange={(e) => handleChange(e,'integer')}
            >
              {selectOptions(hourChoices)}
            </TextField>
            <Typography variant="body2" sx={{ m: 1 }}>
            through
            </Typography>
            <TextField sx={{ m:0 }}
              select
              name="toFilterHour"
              value={userParams.toFilterHour}
              onChange={(e) => handleChange(e,'integer')}
            >
              {selectOptions(hourChoices)}
            </TextField>
        </Stack>
    </FieldsetBox>
  )
}